var canvas = document.createElement('canvas');
var context = canvas.getContext('2d');

var RE_LINUX = /Linux/;
var RE_MAC = /Mac/;
var RE_WINDOWS = /Win/;

module.exports = {
    // on high-DPI screens, different browsers draw bitmaps on canvas
    // in different ways
    // 
    // www.html5rocks.com/en/tutorials/canvas/hidpi/
    getPixelRatio: function () {
        var devicePixelRatio = window.devicePixelRatio || 1;
        var backingStoreRatio = 
            context.backingStorePixelRatio || 
            context.webkitBackingStorePixelRatio ||
            context.mozBackingStorePixelRatio ||
            context.msBackingStorePixelRatio ||
            context.oBackingStorePixelRatio || 1;

        return devicePixelRatio / backingStoreRatio;
    },
    isHighDensity: function () {
        return this.getPixelRatio() > 1.3;
    },
    isLinux: function () {
        return RE_LINUX.test(window.navigator.platform);
    },
    isMac: function () {
        return RE_MAC.test(window.navigator.platform);
    },
    isWindows: function () {
        return RE_WINDOWS.test(window.navigator.platform);
    }
};



//////////////////
// WEBPACK FOOTER
// ./app/src/lib/browser.js
// module id = 2ZbG
// module chunks = 1